import React from "react";
import { Board } from "./components/Board";

const App: React.FC = () => <Board />;

export default App;
